import { Box, Typography } from '@mui/material';

export type SettingsPageHeaderProps = {
    icon: React.ReactNode;
    header: React.ReactNode;
    headerOthers?: React.ReactNode;
    /** Theme spacing units between icon and title (and before `headerOthers`). Default 2. */
    iconColumnGap?: number;
};

/**
 * Title row for {@link SettingsPageLayout}: icon on the left, title to its right, both vertically centered.
 * Uses flex + `gap` (not Stack `spacing` margins) so the icon and title align on the cross axis, not by text baseline.
 */
const SettingsPageHeader = ({ icon, header, headerOthers, iconColumnGap = 2 }: SettingsPageHeaderProps) => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            width: '100%',
            minWidth: 0,
            columnGap: (theme) => theme.spacing(iconColumnGap),
        }}
    >
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                flexShrink: 0,
                minWidth: 0,
                columnGap: (theme) => theme.spacing(iconColumnGap),
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                    lineHeight: 0,
                    paddingTop: '6px',
                    '& svg': { display: 'block' },
                }}
            >
                {icon}
            </Box>
            {typeof header === 'string' ? (
                <Typography
                    component="div"
                    color="primary.main"
                    variant="h4"
                    whiteSpace="nowrap"
                    sx={{
                        m: 0,
                        p: 0,
                        lineHeight: 1,
                        flexShrink: 0,
                    }}
                >
                    {header}
                </Typography>
            ) : (
                <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0, flexShrink: 0, lineHeight: 1 }}>
                    {header}
                </Box>
            )}
        </Box>
        {headerOthers ? (
            <Box
                sx={{
                    display: 'flex',
                    flex: '1 1 auto',
                    minWidth: 0,
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    paddingLeft: (theme) => theme.spacing(2),
                }}
            >
                {headerOthers}
            </Box>
        ) : null}
    </Box>
);

export default SettingsPageHeader;
